import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import _ from "lodash"
import { Asterisk, Check, Globe, User, CircleUser } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { CollectionLoader } from "lib/components"
import { Forms } from "lib/components/forms"



export default function ClientCustomizations(){
  const { cid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { data:_Templates } = queryTools.resource.parseQueryForApi("template.findAll", { AssignedTo: null })
  const { data:_Client } = queryTools.resource.parseQueryForApi("client.findById", { _id: cid })
  const saveMethod = queryTools.resource.save(["client.all"])

  const saveClientConfig = async (newConfig:any) => {
    let clientData = _.cloneDeep(_Client)
    clientData = _.set(clientData, "configs.templates.all.trx_history.rendering.columns", newConfig)
    console.log(clientData)
    saveMethod.mutate({ resource: "client", data: {...clientData, _id: _Client._id} })
  }

  if( !_Client ) return <></>
  return (
    <div className="w-full flex flex-col pt-4">
      <h3 className="w-full text-lg uppercase pb-1 pl-2 mb-4 border-b border-solid border-slate-700">Client Customizations</h3>

      <p>Assigning a template to a client means that the template can be customized specifically for that client. Other clients ccan still use the template if you want, but they will have only the default settings.</p> 

      <div className="w-full flex justify-start items-start gap-3">
        <div className="w-3/12 border border-solid border-slate-700">
          <CollectionLoader
            collection={_Templates}
            selectFn={(item:any) => console.log(item)}
            selectProp="_id"
            labelProp="Title"
          />
        </div>
      </div>

      <p>No templates have been assigned to this client yet.</p>
    </div>
  )
}